export type TwinTowerAdditionStrategy = 'make-ten';
export type TwinTowerId = 'a' | 'b';

export interface TwinTowerCombineConfig {
  readonly id: string;
  readonly skillId: string;
  readonly addendA: number;
  readonly addendB: number;
  readonly strategy: TwinTowerAdditionStrategy;
  readonly target: number;
  readonly composeInto: TwinTowerId;
  readonly landmark: 10;
  readonly completionWorldEvent: string;
}

export function validateTwinTowerCombineConfig(config: TwinTowerCombineConfig) {
  const values = [config.addendA, config.addendB, config.target, config.landmark];
  if (values.some(value => !Number.isInteger(value) || value < 0)) {
    throw new RangeError('Twin Tower values must be non-negative integers.');
  }
  if (config.addendA + config.addendB !== config.target) {
    throw new RangeError('Twin Tower target must equal addendA + addendB.');
  }

  const destination = config.composeInto === 'a' ? config.addendA : config.addendB;
  const source = config.composeInto === 'a' ? config.addendB : config.addendA;
  const needed = config.landmark - destination;
  if (needed <= 0 || needed > source) {
    throw new RangeError('A make-ten challenge must be able to move a positive quantity into the landmark tower.');
  }
  return config;
}

export const ADDITION_CITADEL_MAKE_TEN_1 = validateTwinTowerCombineConfig({
  id: 'addition-citadel-make-ten-1',
  skillId: 'math-addition-make-ten',
  addendA: 8,
  addendB: 5,
  strategy: 'make-ten',
  target: 13,
  composeInto: 'a',
  landmark: 10,
  completionWorldEvent: 'citadel-gate-stage-1',
});
